import { render } from "./AllDeliveries.vue?vue&type=template&id=0a65d9f6"
import script from "./AllDeliveries.vue?vue&type=script&lang=js"
export * from "./AllDeliveries.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__